import Page from "../components/Layout/Page";

export default function AdvertisingDisclosure() {
  return (
    <Page title="Advertising Disclosure">
      <div id="otnotice-75d794e4-063c-48b5-b5b5-f1da553764cd" className="mt-5 prose max-w-none text-gray-500 prose-a:text-sky-600 prose-h2:text-sky-600"></div>
    </Page>
  )
}